import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MultiSelectModule } from 'primeng/multiselect';
import { NgIf } from '@angular/common';
import { SharedModule } from 'primeng/api';
import { TopicStore } from '../../../stores/topic/topic.state';
import { FormsModule } from '@angular/forms';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

@Component({
  selector: 'app-topic-filter-dropdown',
  standalone: true,
  imports: [
    MultiSelectModule,
    NgIf,
    SharedModule,
    FormsModule,
    IconFieldModule,
    InputIconModule,
  ],
  templateUrl: './topic-filter-dropdown.component.html',
  styleUrl: './topic-filter-dropdown.component.scss',
})
export class TopicFilterDropdownComponent {
  readonly topicStore = inject(TopicStore);

  @Input() styleClass = '';
  @Input() label = 'Themen';
  @Input() selectedTopics?: string[] = [];
  @Output() selectedTopicsChange = new EventEmitter<string[]>();

  /**
   * Updates the local selection and emits it to the parent.
   *
   * @param {string[]} topicIds - The newly selected topic ids.
   * @return {void} This method does not return a value.
   */
  onTopicsChange(topicIds: string[]): void {
    this.selectedTopics = topicIds;
    this.selectedTopicsChange.emit(topicIds);
  }
}
